import { useQuery } from '@tanstack/react-query'

import { getAllItems, type GetAllItemsOptions } from '@flecto/api/saas'

type QueryPayload = GetAllItemsOptions & {
  insurable?: boolean
  enabled?: boolean
}

export function useQueryGetAllItems(
  options?: QueryPayload,
  insurable?: boolean
) {
  const CACHE_DURATION = 1000 * 60 * 2 // 2 minutes

  return useQuery({
    queryKey: ['QueryGetAllItems', options],
    queryFn: async () => await getAllItems(insurable, options),
    enabled: options?.enabled,
    staleTime: CACHE_DURATION,
  })
}
